import React, { useState, useEffect, useMemo } from 'react';
import CryptoStep2 from './CryptoStep2';
const CryptoStep1 = ({ setCurrentStep, walletData, purchaseData, setPurchaseData }) => {
   // const [equivalentValue, setEquivalentValue] = useState({ usd: 0, propt: 0 });
   const [equivalentValue, setEquivalentValue] = useState({ crypto: 0, propt: 0 });
   const [error, setError] = useState('');
   const disableValidation = true; // Para pruebas
   // const [livePrices, setLivePrices] = useState(null);
   const [showUsd, setShowUsd] = useState(true);
   const selectedWallet = walletData.find(w => w.currency === purchaseData.sourceCurrency);
   const availableBalance = selectedWallet ? selectedWallet.amount : 0;
   const [usdAmount, setUsdAmount] = useState('');


   const livePrices = useMemo(() => {
      if (!walletData || walletData.length === 0) return null;

      return walletData.reduce((acc, wallet) => {
         if (wallet.rate) {
            acc[wallet.currency] = wallet.rate;
         }
         return acc;
      }, {});
   }, [walletData]);

   // Usamos useMemo para que esta lista solo se recalcule si cambian los datos
   const availableOptions = useMemo(() => {
      // Primero, tomamos solo las wallets relevantes 
      const relevantWallets = walletData.filter(
         w => ['BTC', 'ETH', 'POL'].includes(w.currency)
      );

      // Si la validación está desactivada, mostramos todas
      if (disableValidation) {
         return relevantWallets;
      }

      // Si la validación está activada, filtramos por balance > 0
      return relevantWallets.filter(w => parseFloat(w.amount || 0) > 0);
   }, [walletData, disableValidation]);
   const hasNoFunds = !disableValidation && availableOptions.length === 0;


   // useEffect para calcular la conversión cuando el usuario escribe
   useEffect(() => {
      if (!usdAmount || isNaN(usdAmount) || !livePrices) {
         setEquivalentValue({ crypto: 0, propt: 0 });
         return;
      }

      const numericUsdAmount = parseFloat(usdAmount);
      const cryptoPrice = livePrices[purchaseData.sourceCurrency] || 0;
      const proptPrice = livePrices['PROPT'] || 22.0;

      const cryptoValue = cryptoPrice > 0 ? numericUsdAmount / cryptoPrice : 0;
      const proptValue = proptPrice > 0 ? numericUsdAmount / proptPrice : 0;

      setEquivalentValue({ crypto: cryptoValue, propt: proptValue });

      // Sincroniza los datos importantes con el componente padre (BuyModal)
      setPurchaseData(prev => ({
         ...prev,
         sourceAmount: cryptoValue, // El monto en crypto que se gastará
         usdEquivalent: numericUsdAmount // El monto en USD
      }));

      // Validación de balance
      if (!disableValidation && cryptoValue > availableBalance) {
         setError(`Amount exceeds your balance of ${availableBalance.toFixed(8)} ${purchaseData.sourceCurrency}`);
      } else {
         setError('');
      }
   }, [usdAmount, purchaseData.sourceCurrency, livePrices, availableBalance, disableValidation, setPurchaseData]);

   const handleCurrencyChange = (e) => {
      setPurchaseData(prev => ({ ...prev, sourceCurrency: e.target.value }));
      setUsdAmount(''); // Resetea el monto al cambiar de moneda
      setError('');
   };
   const handleAmountChange = (e) => {
      const value = e.target.value;
      if (/^\d*\.?\d*$/.test(value)) {
         setUsdAmount(value);
      }
   };
   const toggleCurrencyView = () => {
      setShowUsd(prev => !prev);
   };

   const handleContinue = () => {
      if (!error && usdAmount > 0) {
         setCurrentStep(2);
      }
   };

   useEffect(() => {
      const isSelectedCurrencyAvailable = availableOptions.some(
         opt => opt.currency === purchaseData.sourceCurrency
      );

      if (!isSelectedCurrencyAvailable && availableOptions.length > 0) {
         setPurchaseData(prev => ({
            ...prev,
            sourceCurrency: availableOptions[0].currency
         }));
      }
   }, [availableOptions, purchaseData.sourceCurrency, setPurchaseData]);


   // El estado de carga ahora depende de si ya tenemos los precios (vía props)
   if (!livePrices) {
      return <div className="modal_content_body px-4 text-center"><h4>Syncing prices...</h4></div>;
   }



   const isFormValid = usdAmount > 0 && !error && !hasNoFunds;
   return (
      <div className="modal_content_body px-4">
         <div className="withdraw-crypto-form">
            <h3 className="ppt_form_title mb-4 text-center">Crypto payment by <img src={process.env.PUBLIC_URL + '/assets/img/logo_fpay.svg'} alt="" className='ps-2' /></h3>
            <div className="d-flex flex-column align-items-center">
               <div className="w-100 mb-3" style={{ maxWidth: '370px' }}>
                  <div className="position-relative">
                     <select
                        name="sourceCurrency"
                        value={purchaseData.sourceCurrency}
                        onChange={handleCurrencyChange}
                        className='form-select w-100 mb-3'
                        style={{ maxWidth: '370px' }}
                     >
                        {availableOptions.length > 0 ? (
                           availableOptions.map(wallet => (
                              <option key={wallet.currency} value={wallet.currency}>
                                 {wallet.currency} (Balance: {parseFloat(wallet.amount || 0).toFixed(8)})
                              </option>
                           ))
                        ) : (
                           <option disabled>No crypto with balance available</option>
                        )}
                     </select>
                  </div>
               </div>
               <div className="d-flex align-items-center mb-1 gap-3">
                  <div className="cifra_chg">
                     <div className="cifra_chg_dolares"
                        style={{
                           fontSize: '68px',
                           display: showUsd ? 'flex' : 'none'
                        }}
                     >
                        <div className='d-flex align-items-center'>
                           <span className="text-dark">$</span>
                           <input
                              type="text"
                              name="usdAmount"
                              value={usdAmount}
                              onChange={handleAmountChange}
                              placeholder="0.00"
                              disabled={hasNoFunds}
                              className="border-0 bg-none"
                              style={{ fontSize: '68px', maxWidth: '200px', outline: 'none' }}
                           />
                           <span style={{ fontSize: '18px', transform: 'translateY(-6px)' }}>USD</span>
                        </div>
                     </div>
                     <div className="cifra_chg_crypto"
                        style={{
                           fontSize: '68px',
                           display: showUsd ? 'none' : 'flex'
                        }}
                     >
                        <div className="d-flex align-items-center gap-3">
                           <div className="text-black">
                              {equivalentValue.propt.toFixed(4)}
                           </div>
                           <span style={{ fontSize: '18px', transform: 'translateY(-6px)' }}>PROPT</span>
                        </div>
                     </div>
                  </div>
                  <div className="cifra_chg_btn">
                     <div className="d-flex align-items-center flex-column justify-content-center">
                        <span
                           className="ppt_btn_convert_crypto pointer"
                           onClick={toggleCurrencyView}
                           style={{ cursor: 'pointer' }}
                        ><svg width="53" height="52" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_229_16618)">
                                 <path d="M44.1498 16.8444C44.6388 17.2443 44.7105 17.9641 44.3109 18.4527L24.3491 42.8595L31.2539 42.1678C31.8824 42.1048 32.4422 42.5627 32.5049 43.191C32.5364 43.505 32.4376 43.8022 32.2526 44.0285C32.0675 44.2548 31.7958 44.4105 31.4817 44.442L21.8315 45.4088C21.203 45.4718 20.6432 45.0139 20.5805 44.3856L19.6137 34.7354C19.5507 34.1069 20.0086 33.5471 20.6369 33.4843C21.2651 33.4216 21.8252 33.8792 21.8879 34.5075L22.5796 41.4123L42.5414 17.0055C42.941 16.5169 43.6607 16.4444 44.1498 16.8444ZM30.9257 6.46133L21.2755 7.42814C20.647 7.4911 20.1891 8.05093 20.2523 8.67918C20.3154 9.30743 20.8751 9.76552 21.5033 9.70237L28.408 9.01063L8.4463 33.4174C8.04668 33.906 8.11838 34.6258 8.60743 35.0258C9.09648 35.4258 9.81618 35.3532 10.2158 34.8646L30.1775 10.4579L30.8693 17.3626C30.9323 17.9911 31.4921 18.4489 32.1203 18.3858C32.4344 18.3543 32.7061 18.1986 32.8912 17.9723C33.0762 17.746 33.175 17.4488 33.1435 17.1348L32.1767 7.48453C32.114 6.85624 31.5539 6.39819 30.9257 6.46133Z" fill="black"></path>
                              </g>
                              <defs>
                                 <clipPath id="clip0_229_16618">
                                    <rect width="36.5755" height="36.5755" fill="white" transform="translate(0.644531 28.5132) rotate(-50.721)"></rect>
                                 </clipPath>
                              </defs>
                           </svg>
                        </span>
                        <b>{showUsd ? "PROPT" : "USD"}</b>
                     </div>
                  </div>
               </div>
               {/* <div className="d-flex align-items-start mb-5">
                  <div className="d-flex align-items-center" style={{ fontSize: '38px', lineHeight: '100%' }}>
                     <input
                        placeholder="0000000"
                        className="border-0 bg-none"
                        type="text"
                        value=""
                        name="buyAmount"
                        style={{ fontSize: '38px', maxWidth: '166px', outline: 'none' }} />
                     <span
                        className="position-relative"
                        style={{ fontSize: '18px', lineHeight: '100%', transform: 'translateY(-6px)' }}>
                        ETH
                     </span>
                  </div>
               </div> */}
               <div className="mb-3 text-muted" style={{ minHeight: '24px' }}>
                  {hasNoFunds ? (
                     <small className="text-danger">You have no available crypto balance to make a purchase.</small>
                  ) : (
                     <small>
                        ≈ {equivalentValue.crypto.toFixed(8)} {purchaseData.sourceCurrency} ≈ {equivalentValue.propt.toFixed(4)} PROPT
                     </small>
                  )}
               </div>
               {error && <small className="text-danger mb-3">{error}</small>}
               <button className="ppt_btn_primary alt" onClick={handleContinue} disabled={!isFormValid}>
                  Continue
               </button>
            </div>
         </div>
      </div>
   );
};
export default CryptoStep1;